import { render, staticRenderFns } from "./TeamView.vue?vue&type=template&id=04febe0b&scoped=true&"
import script from "./TeamView.vue?vue&type=script&lang=ts&"
export * from "./TeamView.vue?vue&type=script&lang=ts&"
import style0 from "./TeamView.vue?vue&type=style&index=0&id=04febe0b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04febe0b",
  null
  
)

export default component.exports